import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {LatLngBounds} from 'leaflet';
import {Observable, of} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {switchMap} from 'rxjs/operators';
import {checkLatValue, checkLonValue} from '../../dashboard-utility-functions';
import {ProjectBusinessLogicFilterModel} from '../../../shared/project-business-logic-filter/project-business-logic-filter.model';
import {GeopointModel} from '../../../shared/models/geopoint.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardGeopointsService {
  private readonly pageSize = 1000;

  constructor(
    protected http: HttpClient
  ) {
  }

  protected _itemsReceivedCount: number = null;

  public get itemsReceivedCount() {
    return this._itemsReceivedCount;
  }

  protected _itemsTotalCount: number = null;

  public get itemsTotalCount() {
    return this._itemsTotalCount;
  }

  private buildGeopointSearchKey(key: string): string {
    return `GeopointSearch[${key}]`;
  }

  public getItems(
    leafletBoundaryBox: LatLngBounds,
    projectBusinessLogicFilter: ProjectBusinessLogicFilterModel,
    extraParams: MapGeoDataParams | null,
  ): Observable<Array<GeopointModel>> {
    let params = new HttpParams()
      .append('fields', 'id,name,description,geometry,geopoint-type,geopoint-type.type,geopoint-type.image')
      .append('page', '1')
      .append('per-page', this.pageSize.toString())
      .append(this.buildGeopointSearchKey('min_lat'), checkLatValue('min', leafletBoundaryBox.getSouth()).toString())
      .append(this.buildGeopointSearchKey('min_lon'), checkLonValue('min', leafletBoundaryBox.getWest()).toString())
      .append(this.buildGeopointSearchKey('max_lat'), checkLatValue('max', leafletBoundaryBox.getNorth()).toString())
      .append(this.buildGeopointSearchKey('max_lon'), checkLonValue('max', leafletBoundaryBox.getEast()).toString());
    if (projectBusinessLogicFilter) {
      if (projectBusinessLogicFilter.project_id !== null) {
        params = params.append(this.buildGeopointSearchKey('project_id'), projectBusinessLogicFilter.project_id.toString());
      }
      if (projectBusinessLogicFilter.business_logic_id !== null) {
        params = params.append(this.buildGeopointSearchKey('business_logic_id'), projectBusinessLogicFilter.business_logic_id.toString());
      }
    }
    if (extraParams) {
      Object.entries(extraParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params = params.append(this.buildGeopointSearchKey(key), value.toString());
        }
      });
    }
    return this.http.get<Array<GeopointModel>>(
      environment.apiBasepoint + 'geopoint',
      {observe: 'response', params: params}
    ).pipe(
      switchMap(
        (response) => {
          this._itemsTotalCount = parseInt(response.headers.get('X-Pagination-Total-Count'), 10);
          this._itemsReceivedCount = (response.body as Array<GeopointModel>).length;
          return of(response.body);
        }
      ),
    );
  }
}
